// Keychain Case PDP — vanilla JS (gallery, pack selector, FAQ accordion, sticky
// bar, single-variant add-to-cart). Reads pack data from the data-tm-pdp-keyring
// JSON blob rendered server-side by sections/tm-pdp-keyring.liquid.

(function () {
  const root = document.querySelector('[data-tm-pdp-keyring]');
  if (!root) return;

  let CONFIG;
  try {
    CONFIG = JSON.parse(root.getAttribute('data-tm-pdp-keyring'));
  } catch (e) {
    console.error('Keychain PDP: malformed config', e);
    return;
  }

  const PACKS = CONFIG.packs || [];
  const PRODUCT_TITLE = CONFIG.productTitle || 'Leather AirTag Keychain Case';
  const MID = ' · ';

  const state = {
    packId: Number(CONFIG.defaultPack) || PACKS[0]?.id,
    galIdx: 0,
  };

  // ---- element refs ----
  const packCards = root.querySelectorAll('.kc-pack');
  const elPrice = root.querySelector('.kc-price');
  const elCompare = root.querySelector('.kc-compare');
  const elSave = root.querySelector('.kc-save');
  const elMeta = root.querySelector('.kc-meta');
  const elCtaPrice = root.querySelector('.kc-cta-price');

  const scName = root.querySelector('.kc-sticky .sc-name');
  const scPrice = root.querySelector('.kc-sticky .sc-price');
  const scCompare = root.querySelector('.kc-sticky .sc-compare');
  const scThumb = root.querySelector('.kc-sticky-left img');

  const slides = root.querySelectorAll('.kc-slide');
  const thumbs = root.querySelectorAll('.kc-thumb');
  const counter = root.querySelector('.kc-counter');
  const slide0Img = slides[0]?.querySelector('img');
  const thumb0Img = thumbs[0]?.querySelector('img');
  const len = slides.length;

  const pack = () => PACKS.find((p) => p.id === state.packId) || PACKS[0];

  // ---- pack selection ----
  function applyPack() {
    const p = pack();
    if (!p) return;
    packCards.forEach((c) => c.classList.toggle('active', String(c.dataset.packId) === String(p.id)));
    if (elPrice) elPrice.textContent = '$' + p.price;
    if (elCompare) elCompare.textContent = '$' + p.compare;
    if (elSave) elSave.textContent = p.save;
    if (elMeta) elMeta.textContent = p.each + MID + 'Free U.S. shipping' + MID + '30-day returns';
    if (elCtaPrice) elCtaPrice.textContent = '$' + p.price;
    if (scName) scName.textContent = p.name;
    if (scPrice) scPrice.textContent = '$' + p.price;
    if (scCompare) scCompare.textContent = '$' + p.compare;

    // swap pack hero into slide 0 + thumb 0 + sticky thumb, reset to slide 0
    if (p.heroImg) {
      if (slide0Img) slide0Img.src = p.heroImg;
      if (thumb0Img) thumb0Img.src = p.heroImg;
    }
    state.galIdx = 0;
    applyGallery();
  }

  packCards.forEach((card) => {
    card.addEventListener('click', () => {
      state.packId = Number(card.dataset.packId);
      applyPack();
    });
  });

  // ---- gallery ----
  function applyGallery() {
    slides.forEach((s, i) => s.classList.toggle('active', i === state.galIdx));
    thumbs.forEach((t, i) => t.classList.toggle('active', i === state.galIdx));
    if (counter) counter.textContent = (state.galIdx + 1) + ' / ' + len;
    const curImg = slides[state.galIdx]?.querySelector('img');
    if (scThumb && curImg) scThumb.src = curImg.getAttribute('src');
  }

  function go(n) {
    state.galIdx = ((n % len) + len) % len;
    applyGallery();
  }

  root.querySelector('.kc-arrow.left')?.addEventListener('click', () => go(state.galIdx - 1));
  root.querySelector('.kc-arrow.right')?.addEventListener('click', () => go(state.galIdx + 1));
  thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));

  // ---- FAQ accordion ----
  const faqItems = root.querySelectorAll('.kc-faq-item');
  faqItems.forEach((item) => {
    const q = item.querySelector('.kc-faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      faqItems.forEach((it) => it.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ---- sticky bar ----
  const stickyBar = root.querySelector('.kc-sticky');
  if (stickyBar) {
    const onScroll = () => stickyBar.classList.toggle('show', window.scrollY > 620);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- checkout: add selected variant, go to checkout ----
  async function checkout() {
    const p = pack();
    if (!p || !p.variantId) {
      alert('This product is not configured for checkout yet. Set the pack variant IDs in the theme editor.');
      return;
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(p.variantId), quantity: 1 }] }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.description || body.message || ('HTTP ' + res.status));
      }
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      alert('Could not start checkout: ' + err.message);
    }
  }

  const form = root.querySelector('form[data-tm-keyring-form]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      checkout();
    });
  }
  root.querySelector('.kc-sticky .sc-btn')?.addEventListener('click', checkout);

  // ---- init ----
  applyPack();
})();
